import { atom } from './atom';
import { base } from './base';
import { electric } from './electric';
import { fresh } from './fresh';
import { galapagos } from './galapagos';
import { opensense } from './opensense';
import { raspberry } from './raspberry';
import { seafoam } from './seafoam';
import { slate } from './slate';

const themes = {
  atom,
  electric,
  fresh,
  galapagos,
  opensense,
  raspberry,
  seafoam,
  slate
};

export { base, themes };
